import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CfetPageComponentsModule } from '../cfet-page-components/cfet-page-components.module';
import { AbsMessagesModule, AbsStepTrackerModule, AbsTooltipModule, AbsTabsModule } from '@att-ebiz/abs-components-bc';
import { CfetSharedModule } from '../cfet-shared/cfet-shared.module';
import { CfetCoreModule } from '../cfet-core/cfet-core.module';
import { CfetScreensRoutingModule } from './cfet-screens-routing.module';
import {
  AffiliationCodeComponent, AffiliationCodeUtfComponent, CustomerEligibilityComponent, CustomerInformationComponent,
  CustomerProfileComponent, CustomerInformationUtfComponent, CustomerProfileUtfComponent, CompleteProfileComponent,
  SessionTimeOutComponent, SessionTimeOutUtfComponent, ErrorPageComponent, ErrorPageUtfComponent,
  UtfRegistrationVerifyComponent, UtfAuthPageComponent, CustomerEligibilityUtfComponent, CompleteProfileUtfComponent,
  UtfAuthSingleIdComponent, UtfUnauthPageComponent, UtfSyncInfoComponent, UtfSyncingInformationComponent
} from './index';

@NgModule({
  declarations: [
    CustomerEligibilityComponent,
    CustomerInformationComponent,
    CustomerProfileComponent,
    CustomerProfileUtfComponent,
    AffiliationCodeComponent,
    CompleteProfileComponent,
    CompleteProfileUtfComponent,
    SessionTimeOutComponent,
    ErrorPageComponent,
    UtfRegistrationVerifyComponent,
    UtfAuthPageComponent,
    CustomerEligibilityUtfComponent,
    CustomerInformationUtfComponent,
    AffiliationCodeUtfComponent,
    ErrorPageUtfComponent,
    SessionTimeOutUtfComponent,
    UtfAuthSingleIdComponent,
    UtfUnauthPageComponent,
    UtfSyncInfoComponent,
    UtfSyncingInformationComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  imports: [
    CommonModule,
    CfetCoreModule,
    CfetPageComponentsModule,
    CfetSharedModule,
    CfetScreensRoutingModule,
    AbsMessagesModule,
    AbsStepTrackerModule,
    AbsTooltipModule,
    AbsTabsModule
  ]
})
export class CfetScreensModule { }
